import { useEditor, EditorContent } from "@tiptap/react";
import StarterKit from "@tiptap/starter-kit";

interface MyEditorProps {
  value: string;
  onChange: (content: string) => void;
}

const MyEditor: React.FC<MyEditorProps> = ({ value, onChange }) => {
  const editor = useEditor({
    extensions: [StarterKit],
    content: value,
    onUpdate: ({ editor }) => {
      onChange(editor.getHTML());
    },
  });

  if (!editor) {
    return null;
  }

  return (
    <div className="border rounded-lg p-3">
      <div className="flex gap-2 mb-2">
        <button type="button" onClick={() => editor.chain().focus().toggleBold().run()} className="px-3 py-1 border rounded">
          Bold
        </button>

        <button type="button" onClick={() => editor.chain().focus().toggleItalic().run()} className="px-3 py-1 border rounded">
          Italic
        </button>

        <button type="button" onClick={() => editor.chain().focus().toggleBulletList().run()} className="px-3 py-1 border rounded">
          List
        </button>
      </div>

      <EditorContent editor={editor} />
    </div>
  );
};

export default MyEditor;
